import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { appTheme } from '../../../theme';
import { mediaQuery } from '../../common';

const InfoBox = styled.div`
  background-color: ${appTheme.system.passive};
  border: 3px solid ${appTheme.system.border};
  flex: 1;
  padding: 2em;

  ${/* sc-custom '@media'*/ mediaQuery.medium`
    padding: 2%;
  `};

  ${/* sc-custom '@media'*/ mediaQuery.large`
    display: flex;
    flex-direction: column;
  `};
`;

const InfoBoxTitle = styled.h2`
  flex: 1;
  font-size: 18px;
  margin: 0;
  text-align: center;
`;

const InfoBoxContent = styled.p`
  flex: 5;
`;

function InfoCard({ children, title }) {
  return (
    <InfoBox>
      <InfoBoxTitle>{title}</InfoBoxTitle>
      <InfoBoxContent>{children}</InfoBoxContent>
    </InfoBox>
  );
}

InfoCard.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
};

export default InfoCard;



// WEBPACK FOOTER //
// ./src/modules/PublicHomePage/components/InfoCard.js